import { Checkbox, type CheckboxProps } from '@mantine/core';

export const BooleanInput = (props: CheckboxProps) => {
    return <Checkbox {...props} size="xs" error={props.error} />;
};
